import { render, staticRenderFns } from "./AddDrug.vue?vue&type=template&id=10106d0f&scoped=true&"
import script from "./AddDrug.vue?vue&type=script&lang=js&"
export * from "./AddDrug.vue?vue&type=script&lang=js&"
import style0 from "./AddDrug.vue?vue&type=style&index=0&id=10106d0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10106d0f",
  null
  
)

export default component.exports